module.exports = __webpack_public_path__ + "img/part3-4.af3eea21.png";